import { Text } from '@sixui/ui';
import { colorSchemeTokens } from '@sixui/ui/themes/base/colorScheme.stylex';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';

export type ISupportingTextProps = IContainerProps & {
  children: React.ReactNode;
  icon?: React.ReactNode;
  hasError?: boolean;
};

const styles = stylex.create({
  host: {
    color: colorSchemeTokens.onSurface,
  },
  host$hasError: {
    color: colorSchemeTokens.error,
  },
  icon: {
    marginRight: '0.25rem',
  },
});

export const SupportingText: React.FC<ISupportingTextProps> = ({
  sx,
  children,
  icon,
  hasError,
}) => (
  <Text
    variant="body"
    size="sm"
    sx={[styles.host, hasError && styles.host$hasError, sx]}
  >
    {icon && <span {...stylex.props(styles.icon)}>{icon}</span>}
    {children}
  </Text>
);
